import { render, staticRenderFns } from "./AllocationNavigation.vue?vue&type=template&id=2885ecf2&scoped=true&"
import script from "./AllocationNavigation.vue?vue&type=script&lang=ts&"
export * from "./AllocationNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationNavigation.vue?vue&type=style&index=0&id=2885ecf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885ecf2",
  null
  
)

export default component.exports